import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '@core/services/base/base.service';
import { ErrorHandlerService, HttpError } from '@core/services/error-handler.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ThemaChannelGoal } from '../../models/thema-channel-goal/thema-channel-goal.model';

@Injectable({
  providedIn: 'root',
})
export class ThemaChannelGoalService extends BaseService {
  constructor(private httpService: HttpClient, private errorHandlerService: ErrorHandlerService) {
    super();
  }

  public getList(year: number): Observable<ThemaChannelGoal[]> {
    const httpErrors: HttpError[] = [
      {
        statusCode: 404,
        message: 'Impossible de récupérer la liste des chaines. Veuillez essayer plus tard.',
      },
      {
        statusCode: 500,
        message: 'Une erreur est survenue. Veuillez essayer plus tard.',
      },
    ];

    let url = environment.contract_microservice_api_base_url + '/thema_channel_goal/' + year;

    return new Observable(observer => {
      this.httpService
        .get(url)
        .pipe(
          map(response => {
            let themaChannelGoals: ThemaChannelGoal[] = [];
            if (response && response['statusCode'] === 200) {
              themaChannelGoals = response['data'].map(themaChannelGoal => new ThemaChannelGoal(themaChannelGoal));
            }
            return themaChannelGoals;
          })
        )
        .subscribe(
          (response: any) => observer.next(response),
          error => {
            this.errorHandlerService.showErrorMessage(httpErrors, error.status);
            observer.error(error);
          }
        );
    });
  }
}
